import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import WhyUs from "./components/WhyUs";
import Equipment from "./components/Equipment";
import HowItWorks from "./components/HowItWorks";
import Prices from "./components/Prices";
import WorkSlider from "./components/WorkSlider";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <div className="bg-overlay">
        <Header />
        <Hero />
        <Services />
        <WhyUs />
        <Equipment />
        <HowItWorks />
        <Prices />
        <WorkSlider />
        <FAQ />
        <Contact />
        <Footer />
      </div>
    </>
  );
}

export default App;